module.exports = __webpack_public_path__ + "img/shuttle_run.a063af9a.svg";